const SetTemplate = (Template: any, Component: any, fusionAuth:any = null) => {
  return (
    <Template {...fusionAuth}>
      <Component {...fusionAuth} />
    </Template>
  )
}

export default SetTemplate